<div class="production-plan-view">
	@if (isLoadingPlan) {
		<div class="loading-overlay">
			<img class="spinner" src="./assets/spinner2.gif" />
		</div>
	}

	@if (!isLoadingPlan) {
		<div class="filter-bar">
			<div class="plan-name">{{ planName }}</div>
			<div class="filter-group filter-group-all">
				<div class="filter-item filter-item-select">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="batch-select-field">
						<mat-label>{{ 'mes.production-plan.filter.batch' | translate }}</mat-label>
						<mat-select [value]="selectedBatchId" (selectionChange)="onBatchSelectionChange($event)">
							<mat-option value="">
								{{ 'mes.production-plan.filter.all-batches' | translate }}
							</mat-option>
							@for (batch of batches; track batch) {
								<mat-option [value]="batch.id">
									{{ service.getBatchName(batch.id) }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="filter-item filter-item-select">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="batch-select-field">
						<mat-label>
							{{ 'mes.production-plan.filter.order-number' | translate }}
						</mat-label>
						<mat-select [value]="selectedOrderNumber" (selectionChange)="onOrderNumberSelectionChange($event)">
							<mat-option value="">
								{{ 'mes.production-plan.filter.all-order-numbers' | translate }}
							</mat-option>
							@for (orderNumber of orderNumbers; track orderNumber) {
								<mat-option [value]="orderNumber">{{ orderNumber }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="filter-item">
					<mat-checkbox class="filter-checkbox filter-checkbox-completed" [(ngModel)]="showCompleted" (change)="applySortAndFilter()">
						{{ 'mes.production-plan.filter.show-completed' | translate }}
					</mat-checkbox>
				</div>
				<div class="filter-item">
					<mat-checkbox class="filter-checkbox filter-checkbox-inprogress" [(ngModel)]="showInProgress" (change)="applySortAndFilter()">
						{{ 'mes.production-plan.filter.show-in-progress' | translate }}
					</mat-checkbox>
				</div>
				<div class="filter-item">
					<mat-checkbox class="filter-checkbox filter-checkbox-pending" [(ngModel)]="showNotStarted" (change)="applySortAndFilter()">
						{{ 'mes.production-plan.filter.show-not-started' | translate }}
					</mat-checkbox>
				</div>
			</div>
		</div>
	}

	@if (!isLoadingPlan) {
		<div class="table-container">
			<div class="header-wrapper" #headerWrapper>
				<table class="mat-mdc-table" [style.min-width.px]="tableWidth">
					<colgroup>
						@for (col of columns; track col) {
							<col [style.width.px]="col.width" />
						}
					</colgroup>
					<thead>
						<tr>
							@for (col of columns; track col; let i = $index) {
								<th (click)="!col.isStatus && onSort(col.source)" [class.sortable]="!col.isStatus">
									<span class="header-content">
										{{ col.title }}
										@if (!col.isStatus && sortColumn === col.source && sortDirection === 'asc') {
											<span>&#9650;</span>
										}
										@if (!col.isStatus && sortColumn === col.source && sortDirection === 'desc') {
											<span>&#9660;</span>
										}
										@if (col.isStatus && col.planLinksIds?.length) {
											<button mat-icon-button class="plan-links-btn" [matMenuTriggerFor]="planMenu" (click)="$event.stopPropagation()">
												<mat-icon>more_horiz</mat-icon>
											</button>
										}
										<mat-menu #planMenu="matMenu">
											@for (planId of col.planLinksIds; track planId) {
												<button mat-menu-item (click)="navigateToPlan(planId)">
													{{ getPlanName(planId) }}
												</button>
											}
										</mat-menu>
									</span>
									<span class="resize" (click)="$event.stopPropagation()" (mousedown)="startColumnResize($event, i)"></span>
								</th>
							}
						</tr>
					</thead>
				</table>
			</div>
			<cdk-virtual-scroll-viewport class="viewport" [itemSize]="41" [minBufferPx]="400" [maxBufferPx]="1200">
				<table class="mat-mdc-table" [style.min-width.px]="tableWidth">
					<colgroup>
						@for (col of columns; track col) {
							<col [style.width.px]="col.width" />
						}
					</colgroup>
					<tbody>
						<tr *cdkVirtualFor="let item of items; trackBy: trackByOrderPosition" (click)="openInfoDialogue(item)">
							@for (col of columns; track col) {
								@if (!col.isStatus) {
									<td class="info-column">
										@if (col === columns[0]) {
											<div class="info-cell-content">
												<span>{{ getCellValue(item, col.source) }}</span>
												@if ((noteService.getProductionNotesByAlias(item.orderNumber + ':' + item.position) | async)?.length > 0) {
													<button mat-icon-button type="button" class="note-indicator-button" (click)="openNotes(item, $event)">
														<mat-icon svgIcon="acies_mes_production_notes"></mat-icon>
													</button>
												}
											</div>
										} @else {
											{{ getCellValue(item, col.source) }}
										}
									</td>
								}
								@if (col.isStatus) {
									<td class="status-column">
										<app-terminal-status-cell #statusCell [orderNumber]="item.orderNumber" [position]="item.position" [terminalIds]="col.terminalIds" (click)="openStatusInfoDialogue(item, col, statusCell.status, $event)"></app-terminal-status-cell>
									</td>
								}
							}
						</tr>
					</tbody>
				</table>
			</cdk-virtual-scroll-viewport>
		</div>
	}
</div>
